import { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'

import { LOGIN_PATH } from 'account/login/Login'

import { ProductIds } from 'core'
import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'

import { SelectOption } from 'common/components/dataEntry/formik'

import { useLoginUserV2 } from 'common/hooks'

import NotFound from 'errorPages/NotFound'

import ChangePassword from '../account/changePassword'
import { ROUTE_PATHS } from '../common/routePaths'
import AiAnalytics, { AI_ANALYTICS_PATH } from './AiAnalytics'
import JsonContent, { JSON_PATH } from './AiAnalytics/JsonContent'
import CannedMessages, { CANNED_MESSAGES_PATH } from './CannedMessages'
import DocReviewDashboardWrapper from './DocReviewDashboardWrapper'
import Expenses, { EXPENSES_PATH } from './Expenses'
import Home, { HOME_PATH } from './Home'
import KeywordManagement, { KEYWORD_MANAGEMENT } from './KeywordManagement'
import Premiums, { PREMIUMS_PATH } from './Premiums'
import SearchExpenses, { SEARCH_EXPENSES_PATH } from './searchExpenses/index'
import SearchPremiums from './searchPremiums'

export const DOC_REVIEW_DASHBOARD_PATH = '/doc-review-dashboard'

export enum NavigationMapping {
  Home = 1,
  Premiums = 2,
  Expenses = 3,
  SearchExpenses = 4,
  CannedMessages = 5,
  ChangePassword = 6,
  SearchPremiums = 7,
  AiAnalytics = 8,
  AiAnalyticsJson = 9,
  KeywordManagement = 10,
}

export const navigationPathMapping = new Map<string, number>([
  [HOME_PATH, NavigationMapping.Home],
  [PREMIUMS_PATH, NavigationMapping.Premiums],
  [EXPENSES_PATH, NavigationMapping.Expenses],
  [SEARCH_EXPENSES_PATH, NavigationMapping.SearchExpenses],
  [CANNED_MESSAGES_PATH, NavigationMapping.CannedMessages],
  [AI_ANALYTICS_PATH, NavigationMapping.AiAnalytics],
  [KEYWORD_MANAGEMENT, NavigationMapping.KeywordManagement],
])

export const ProductOptionsSelect: SelectOption[] = [
  { id: null, name: 'All Products' },
  { id: ProductIds.GroupHraId, name: 'GroupHra' },
  { id: ProductIds.QsehraId, name: 'QSEHRA' },
  { id: ProductIds.IchraId, name: 'ICHRA' },
]

export const PremiumProductOptionsSelect: SelectOption[] = [
  { id: -1, name: 'All Products' },
  { id: ProductIds.QsehraId, name: 'QSEHRA' },
  { id: ProductIds.IchraId, name: 'ICHRA' },
]

const DocReviewDashboard = () => {
  const history = useHistory()
  const { user } = useLoginUserV2()
  useEffect(() => {
    if (!isUserAllowedToEnterDashbaord(user)) history.push(LOGIN_PATH)
  }, [])

  const isUserAllowedToEnterDashbaord = (user: User): boolean => {
    return user !== null && user.permissions.includes(Permissions.AccessDocReviewDashboard)
  }

  return (
    user && (
      <DocReviewDashboardWrapper user={user}>
        <Switch>
          <Route
            key={NavigationMapping.ChangePassword}
            path={ROUTE_PATHS.DOC_REVIEW_CHANGE_PASSWORD_PATH}
            component={ChangePassword}
          />
          <Route key={NavigationMapping.Home} path={`${DOC_REVIEW_DASHBOARD_PATH}/${HOME_PATH}`} component={Home} />
          <Route
            key={NavigationMapping.Premiums}
            path={`${ROUTE_PATHS.DOC_REVIEW_PREMIUMS}/:id?`}
            component={Premiums}
          />
          <Route
            key={NavigationMapping.SearchPremiums}
            path={ROUTE_PATHS.DOC_REVIEW_SEARCH_PREMIUMS}
            component={SearchPremiums}
          />
          <Route
            key={NavigationMapping.Expenses}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${EXPENSES_PATH}/:id?`}
            component={Expenses}
          />
          <Route
            key={NavigationMapping.SearchExpenses}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${SEARCH_EXPENSES_PATH}`}
            component={SearchExpenses}
          />
          <Route
            key={NavigationMapping.CannedMessages}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${CANNED_MESSAGES_PATH}`}
            component={CannedMessages}
          />
          <Route
            key={NavigationMapping.AiAnalyticsJson}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${AI_ANALYTICS_PATH}/${JSON_PATH}`}
            component={JsonContent}
          />
          <Route
            key={NavigationMapping.AiAnalytics}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${AI_ANALYTICS_PATH}`}
            component={AiAnalytics}
          />
          <Route
            key={NavigationMapping.KeywordManagement}
            path={`${DOC_REVIEW_DASHBOARD_PATH}/${KEYWORD_MANAGEMENT}`}
            component={KeywordManagement}
          />
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </DocReviewDashboardWrapper>
    )
  )
}

export default DocReviewDashboard
